<template>
    <div>
        <rich-client-header-admin />
        <rich-admin-header-secondary-level v-show="isSecondary" />
        <main class="container" :class="{secondary: isSecondary}" style="padding-bottom: 3rem;">
            <slot/>
        </main>
    </div>
</template>

<script>
    import RichClientNavMobile from "../components/c-blocks/RichClientNavMobile";
    import {mapGetters} from 'vuex'
    import RichHeaderSecondaryLevel from "../components/c-blocks/RichHeaderSecondaryLevel";
    import RichClientHeaderAdmin from "../components/c-blocks/richClientHeaderAdmin";
    import RichAdminHeaderSecondaryLevel from "../components/c-blocks/RichAdminHeaderSecondaryLevel";

    export default {
        components: {RichAdminHeaderSecondaryLevel, RichClientHeaderAdmin, RichClientNavMobile},
        data() {
            return {
                isSecondary: false,
            }
        },
        computed: {
            ...mapGetters({
                currentFamily: 'currentFamily'
            })
        },
        methods: {
            checkUserLogin() {
                if (!this.currentFamily) {
                    this.$router.push('/connexion')
                } else {
                    this.checkUserAdmin()
                }
            },
            checkUserAdmin() {
                if (!this.currentFamily.is_admin) {
                    this.$router.push('/deconnexion')
                }
            }
        },
        updated() {
            this.isSecondary = this.$route.meta.isSecondary || false
        },
        created() {
            this.checkUserLogin()
            this.isSecondary = this.$route.meta.isSecondary || false
        }
    }
</script>

<style scoped lang="scss">
    /deep/ main {
        padding-top: 54px;
    }

    /deep/ .main-title {
        margin-bottom: 24px;
    }

    /deep/ main.secondary{
        padding-top: 154px;
    }

    @include screen-m {
        /deep/ main {
            max-width: 800px;
            margin: 0 auto;
            padding-top: 108px;
        }
    }
</style>
